import { useState } from "react"

import EntitySelector from "@/components/EntitySelector.tsx"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs.tsx"
import { getDrivers } from "@/features/logistics/api/getDrivers.ts"
import DriverDetail from "@/features/logistics/components/DriverDetail.tsx"
import DriverDash from "@/features/logistics/components/drivers/Driver.tsx"
import FarmTargets from "@/features/logistics/components/FarmTargets.tsx"
import type { Driver } from "@/features/logistics/types/logisticsTypes.ts"

export default function LogisticsAdmin() {
  const [driver, setDriver] = useState<number>(1)
  return (
    <Tabs defaultValue="targets">
      <TabsList>
        <TabsTrigger value="targets">Farm Targets</TabsTrigger>
        <TabsTrigger value="drivers">Driver Dashboards</TabsTrigger>
        <TabsTrigger value="trips">Trip Detail</TabsTrigger>
      </TabsList>
      <TabsContent value="targets">
        <FarmTargets />
      </TabsContent>
      <TabsContent value="drivers">
        <div className="max-w-[200px] mb-2">
          <EntitySelector<Driver>
            value={driver}
            setValue={setDriver}
            queryKey="drivers"
            fetcher={getDrivers}
            displayProp="name"
          />
        </div>
        <DriverDash id={driver} />
      </TabsContent>
      <TabsContent value="trips">
        <DriverDetail />
      </TabsContent>
    </Tabs>
  )
}
